"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupedLocationsDto = void 0;
const tslib_1 = require("tslib");
const class_transformer_1 = require("class-transformer");
const common_1 = require("@goparrot/common");
const swagger_v4_1 = require("@nestjs/swagger-v4");
const class_validator_1 = require("class-validator");
const GroupedLocationDto_1 = require("./GroupedLocationDto");
class GroupedLocationsDto {
}
tslib_1.__decorate([
    (0, class_transformer_1.Expose)({ groups: [common_1.DefaultExposeGroupEnum.READ] }),
    (0, swagger_v4_1.ApiProperty)({
        type: () => String,
        isArray: true,
        description: 'Merchant name',
    }),
    (0, class_validator_1.IsString)({ always: true }),
    tslib_1.__metadata("design:type", String)
], GroupedLocationsDto.prototype, "merchantName", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Expose)({ groups: [common_1.DefaultExposeGroupEnum.READ] }),
    (0, swagger_v4_1.ApiProperty)({
        type: () => String,
        isArray: true,
        description: 'Merchant ID',
    }),
    (0, class_validator_1.IsString)({ always: true }),
    tslib_1.__metadata("design:type", String)
], GroupedLocationsDto.prototype, "merchantId", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Expose)({ groups: [common_1.DefaultExposeGroupEnum.READ] }),
    (0, swagger_v4_1.ApiProperty)({
        type: () => GroupedLocationDto_1.GroupedLocationDto,
        isArray: true,
        description: 'Grouped Location list',
    }),
    (0, class_validator_1.ValidateNested)({ always: true }),
    tslib_1.__metadata("design:type", Array)
], GroupedLocationsDto.prototype, "locations", void 0);
exports.GroupedLocationsDto = GroupedLocationsDto;
//# sourceMappingURL=GroupedLocationsDto.js.map